if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        this.querySelectorAll('[data-gallery-direction]').forEach((button) => {
          button.addEventListener('click', () => this.showAdjacentMedia(button.dataset.galleryDirection));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      showAdjacentMedia(direction) {
        const galleryList = this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
        const mediaItems = [...(galleryList?.children || [])].filter(
          (item) => item.matches('[data-media-id]') && !item.classList.contains('hidden')
        );
        if (mediaItems.length < 2) return;

        const activeIndex = mediaItems.findIndex((item) => item.classList.contains('is-active'));
        const currentIndex = activeIndex >= 0 ? activeIndex : 0;
        const offset = direction === 'previous' ? -1 : 1;
        const targetIndex = (currentIndex + offset + mediaItems.length) % mediaItems.length;
        const target = mediaItems[targetIndex];
        this.setActiveMedia(target.dataset.mediaId, false);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = [...this.elements.thumbnails.querySelectorAll('[data-target]')].find(
          (candidate) =>
            candidate.dataset.target === mediaId || candidate.dataset.target.endsWith(`-${mediaId}`) || mediaId.endsWith(`-${candidate.dataset.target}`)
        );
        this.setActiveThumbnail(activeThumbnail);
        this.updateImageCounter(mediaId);
        if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      updateImageCounter(mediaId) {
        const galleryList = this.elements.viewer.querySelector('[id^="Slider-Gallery"]');
        const mediaItems = [...(galleryList?.children || [])].filter(
          (item) => item.matches('[data-media-id]') && !item.classList.contains('hidden')
        );
        const activeIndex = mediaItems.findIndex(
          (item) => item.dataset.mediaId === mediaId || item.dataset.mediaId.endsWith(`-${mediaId}`) || mediaId.endsWith(`-${item.dataset.mediaId}`)
        );
        const current = this.elements.viewer.querySelector('.slider-counter--current');
        const total = this.elements.viewer.querySelector('.slider-counter--total');
        if (current && activeIndex >= 0) current.textContent = activeIndex + 1;
        if (total) total.textContent = mediaItems.length;
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
